import { BlankState } from '@domain-group/suit-theme'

import BlankStateImage from './assets/no-signs.svg'

const SignboardsBlankState = () => (
  <BlankState boxProps={{ marginBottom: 'large' }} imageUrl={BlankStateImage}>
    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Title>No Signboards</BlankState.Title>

    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Paragraph>
      No signboards to display. Try changing your filters if you have any selected. Signboards will appear here once
      you have approved a signboard for installation or after a signboard is removed
      {/*
     // @ts-expect-error TS2339 */}
    </BlankState.Paragraph>
  </BlankState>
)

export default SignboardsBlankState
